/**
 * Form factor pra coluna `origem` da telemetria. Existe como MÓDULO (e não como
 * hook) porque o interceptor do axios não é componente e não pode chamar
 * `useIsMobile`.
 *
 * ⚠ Mede LARGURA DE JANELA, não aparelho — desktop com janela estreita reporta
 * 'mobile'. É a mesma régua do `useIsMobile` (768px), mantida igual de propósito
 * pra tela e telemetria não discordarem.
 */
const BREAKPOINT_MOBILE = '(max-width: 767px)';

let mq: MediaQueryList | null = null;

function query(): MediaQueryList | null {
  if (mq) return mq;
  try {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
      mq = window.matchMedia(BREAKPOINT_MOBILE);
    }
  } catch {
    mq = null;
  }
  return mq;
}

export function getFormFactor(): 'mobile' | 'web' {
  return query()?.matches ? 'mobile' : 'web';
}
